import { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { environment } from "environment/environment";

const useSectorStrategyExecutionWebsocket = (
  accessToken,
  socketUrl = environment.stockApiDayRangeDataWSUrl,
  destination = environment.sectorStrategyExecutionDestination
) => {
  const [latestTrade, setLatestTrade] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !accessToken || !destination) {
      setIsConnected(false);
      return undefined;
    }

    const client = new Client({
      webSocketFactory: () => new SockJS(socketUrl),
      connectHeaders: { Authorization: `Bearer ${accessToken}` },
      reconnectDelay: 5000,
      connectionTimeout: 10000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      discardWebsocketOnCommFailure: true,
      debug: () => {},
    });

    client.onConnect = () => {
      setIsConnected(true);
      client.subscribe(destination, (message) => {
        try {
          setLatestTrade(JSON.parse(message.body));
        } catch (error) {
          console.error("Unable to read sector strategy execution update:", error);
        }
      });
    };
    client.onStompError = () => setIsConnected(false);
    client.onWebSocketError = () => setIsConnected(false);
    client.onWebSocketClose = () => setIsConnected(false);
    client.onDisconnect = () => setIsConnected(false);
    client.activate();

    return () => {
      setIsConnected(false);
      if (client.active) {
        void client.deactivate().catch((error) => {
          console.error("Unable to close sector execution connection:", error);
        });
      }
    };
  }, [accessToken, destination, socketUrl]);

  return { latestTrade, isConnected };
};

export default useSectorStrategyExecutionWebsocket;
